export default "__VITE_ASSET__CeH_Uq7k__"